// extracted by mini-css-extract-plugin
export default {"hotspotsList":"index_hotspotsList_LVXvA","hotspotsItem":"index_hotspotsItem_Xww4J"};